import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PulseContext = /*#__PURE__*/createContext({});
export const PulseProvider = ({
  controller,
  children
}) => {
  const value = useMemo(() => ({
    controller
  }), [controller]);
  return /*#__PURE__*/_jsx(PulseContext.Provider, {
    value: value,
    children: children
  });
};
export const useEntityController = () => {
  var _useContext;
  return (_useContext = useContext(PulseContext)) === null || _useContext === void 0 ? void 0 : _useContext.controller;
};